import {
  ControlsVisibility,
  WorkflowEngineAction,
  WorkflowEngineActionKind
} from '../../../WorkflowEngine/workflowEngineReducer';
import { ConditionalRuleConfig } from '../../../Controls/Shared/RulesEngine/types';
import { SelectOption } from '../../../Controls/Select/types';
import getControlSchemaProperty from '../../../Shared/jsonSchemaUtilities/getControlSchemaProperty';
import getControlsUtilizeHiddenComponents from '../getControlsUtilizeHiddenComponents';
import getConditionalControls from '../getConditionalControls';
import PageState from '../../../Shared/pageState';

export default (
  pages: PageState[],
  dispatch: (value: WorkflowEngineAction) => void
) => {
  const controlsToHide: string[] = [];
  const conditionalControls = getConditionalControls(pages);

  for (const conditionalControl of conditionalControls) {
    if (!conditionalControl.visible) continue;

    const controlId = getControlSchemaProperty(
      conditionalControl,
      'id'
    ) as string;

    const controlsThatUtilizeHiddenComponents =
      getControlsUtilizeHiddenComponents(pages);

    const isControllerVisible =
      controlsThatUtilizeHiddenComponents.filter(
        (controlUtilizeHiddenComponents) => {
          const configuredOptions = getControlSchemaProperty(
            controlUtilizeHiddenComponents,
            'options'
          ) as unknown as SelectOption[];

          const configuredRules = getControlSchemaProperty(
            controlUtilizeHiddenComponents,
            'rules'
          ) as unknown as ConditionalRuleConfig[];

          let isConfigured = false;

          if (configuredOptions) {
            for (const opt of configuredOptions) {
              if (opt.utilize.split('|').includes(controlId)) {
                isConfigured = true;
                break;
              }
            }
          } else if (configuredRules) {
            for (const rule of configuredRules) {
              if (rule.utilize.split('|').includes(controlId)) {
                isConfigured = true;
                break;
              }
            }
          }

          return isConfigured && controlUtilizeHiddenComponents.visible;
        }
      ).length > 0;

    if (!isControllerVisible) {
      controlsToHide.push(conditionalControl.id);
    }
  }

  dispatch({
    type: WorkflowEngineActionKind.CONTROLS_SET_VISIBLE,
    payload: {
      show: [],
      hide: controlsToHide
    } as ControlsVisibility
  });
};
